import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { CSSProperties } from 'styled-components';

import { Clock } from '@sorare/core/src/atoms/icons/Clock';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import type { TypographyVariant } from '@sorare/core/src/atoms/typography';
import { BodyS } from '@sorare/core/src/atoms/typography';
import { TimeLeft } from '@sorare/core/src/contexts/ticker/TimeLeft';

import type { TaskCampaignText_taskCampaign } from './__generated__/index.graphql';

type Props = {
  taskCampaign: TaskCampaignText_taskCampaign;
  Typo?: TypographyVariant;
};
export const TaskCampaignText = ({ taskCampaign, Typo = BodyS }: Props) => {
  const { color1, color2, name, endDate } = taskCampaign;
  return (
    <Horizontal>
      <Typo
        className="text-gradient-color"
        style={
          {
            '--text-gradient-color': `linear-gradient(323deg, ${color1}, ${color2})`,
          } as CSSProperties
        }
      >
        {name}
      </Typo>
      <TimeLeft
        Layout={({ children }) => (
          <Horizontal as="span" gap={0.5}>
            <Clock color={color1} />
            <Typo
              className="text-gradient-color"
              style={
                {
                  '--text-gradient-color': `linear-gradient(323deg, ${color1}, ${color2})`,
                } as CSSProperties
              }
              bold
            >
              {children}
            </Typo>
          </Horizontal>
        )}
        time={endDate}
      />
    </Horizontal>
  );
};

TaskCampaignText.fragments = {
  taskCampaign: gql`
    fragment TaskCampaignText_taskCampaign on TaskCampaign {
      slug
      endDate
      color1: color(variant: PRIMARY)
      color2: color(variant: SECONDARY)
      name
      tagIconUrl
      tagLabel
    }
  ` as TypedDocumentNode<TaskCampaignText_taskCampaign>,
};
